import { createAction } from '@src/redux/helpers/createAction';
import { SAVE_AS_DRAFT, RETRIEVE_DRAFT } from './constants';
import { callSaveAsDraft, getDraft } from './requests';

export const saveSuperUserDraft = (query, onSuccess, onError) => {
  return createAction({
    type: SAVE_AS_DRAFT,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: callSaveAsDraft,
    },
  });
};

export const retrieveSuperUserDraft = (query, onSuccess, onError) => {
  return createAction({
    type: RETRIEVE_DRAFT,
    cache: false,
    payload: query,
    meta: {
      onSuccess,
      onError,
      async: getDraft,
    },
  });
};
